import React, { useContext, useState } from "react";
import { getformatDate, getformatTime } from "../../../../JsHelpers/DateFormat";
import axios from "axios";
import { toast } from "react-toastify";
import { useMap } from "react-leaflet";
import { popupcontext } from "../../../../context/Popupscontext";
import trans from "../../../../utils";
import { DistanceUnit, SpeedUnit } from "../../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";

export default function PlayBackTripDetails({ HistoryPlayBack, colors, data }) {
	let { setPosIndex } = useContext(popupcontext);
	const [geoCodes, setGeoCode] = useState({});
	const [selectedRow, setSelectedRow] = useState(null);
	const map = useMap();
	const inf = useSelector((state) => state.users.user);
	console.log("Colors", colors);
	const fetchMultipleGeoCodePosition = async (lat, lon, id, type) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
			);

			setGeoCode((prev) => ({
				...prev,
				[id]: {
					...prev[id],
					[type]: response.data.display_name,
				},
			}));
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	const truncateItem = (text) => {
		const maxLength = 45;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	const moveToLocations = (lat, lon, id, index) => {
		setPosIndex(data?.findIndex((i) => i.id === id));
		map.setView([lat, lon]);
		setSelectedRow(index === selectedRow ? null : index);
	};
	console.log("object", HistoryPlayBack);
	return (
		<div className="history-playback-trip-details">
			<div className="trip-details">
				{HistoryPlayBack.map((i, index) => {
					if (!i.data || i.data.length === 0 || !colors) return null;
					console.log("Packet Data", i.data);
					return (
						<div key={index}>
							<div
								className={`row my-1 ${
									selectedRow === index
										? "trip-details-container-active"
										: "trip-details-container"
								}`}
								onClick={() =>
									moveToLocations(
										i?.data[0].latitude,
										i?.data[0].longitude,
										i?.data[0].id,
										index
									)
								}
							>
								<div className="col-lg-2 col-sm-2">
									<div
										className="type-wrapper"
										style={{ backgroundColor: colors[index]?.[0] }}
									>
										{i.type !== "Parking" ? (
											<img
												src={
													i.type === "Moving"
														? `${process.env.PUBLIC_URL}/assets/Route.svg`
														: `${process.env.PUBLIC_URL}/assets/Idle.svg`
												}
												alt="img"
											/>
										) : (
											<img
												src={`${process.env.PUBLIC_URL}/assets/Parking.svg`}
												alt="img"
											/>
										)}
									</div>
								</div>

								<div className="col-lg-3 col-sm-3 text-center">
									<div className="Time d-block">
										<div className="clock">
											{getformatTime(i?.data[0].fixTime)}
										</div>
										<div className="date">
											{getformatDate(i?.data[0].fixTime)}
										</div>
									</div>
									<div className="table-checkbox x-25 my-2">
										<input
											type="checkbox"
											onChange={() => {}}
											name=""
											id=""
											checked={selectedRow === index}
											readOnly
										/>
									</div>
									<div className="Time d-block">
										<div className="clock">
											{getformatTime(i.data[i.data.length - 1].fixTime)}
										</div>
										<div className="date">
											{getformatDate(i.data[i.data.length - 1].fixTime)}
										</div>
									</div>
								</div>
								<div className="col-lg-1 col-sm-1">
									<div className="break-line">
										<div className="circle"></div>
										<div className="line"></div>
										<div className="circle"></div>
									</div>
								</div>
								<div className="col-lg-6 col-sm-6 d-block">
									<div
										className="address text-primary"
										onClick={() =>
											fetchMultipleGeoCodePosition(
												i.data[0].latitude,
												i.data[0].longitude,
												index,
												"start"
											)
										}
										title={geoCodes[index]?.start && geoCodes[index]?.start}
									>
										{geoCodes[index]?.start
											? truncateItem(geoCodes[index]?.start)
											: trans("Get current address")}
									</div>
									<div className="flex-between my-2">
										{i.type === "Moving" && (
											<>
												<div className="flex-between">
													<img
														src={`${process.env.PUBLIC_URL}/assets/TotalDistance.svg`}
														alt="totaldistance"
														className="me-1"
													/>
													<div className="value">
														{DistanceUnit(
															i.data[i.data.length - 1].attributes
																.totalDistance -
																i.data[0].attributes.totalDistance,
															inf?.attributes?.distanceUnit || "km"
														)}
													</div>
												</div>
												<div
													className="flex-between me-1"
													title="average-speed"
												>
													<img
														src={`${process.env.PUBLIC_URL}/assets/Speedmeter.svg`}
														alt="speedmeter"
														className="me-1"
													/>

													<div className="value">
														{SpeedUnit(
															i?.data.reduce(
																(acc, obj) => acc + obj?.speed,
																0
															) / i?.data.length,
															inf?.attributes?.speedUnit || "kn"
														)}
													</div>
												</div>
											</>
										)}

										<div className="flex-between mt-2">
											<img
												src={`${process.env.PUBLIC_URL}/assets/TakenTime.svg`}
												alt="takentime"
												className="me-1"
											/>
											<div className="value">{i?.takenTime}</div>
										</div>
									</div>
									{i.type === "Moving" && (
										<>
											<div
												className="address text-primary"
												title={geoCodes[index]?.end && geoCodes[index]?.end}
												onClick={() =>
													fetchMultipleGeoCodePosition(
														i.data[i.data.length - 1].latitude,
														i.data[i.data.length - 1].longitude,
														index,
														"end"
													)
												}
											>
												{geoCodes[index]?.end
													? truncateItem(geoCodes[index]?.end)
													: trans("Get current address")}
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
